(function ($) {
	"use strict";

	toastr.options = {
		"positionClass": "toast-top-center",
		"timeOut": 60000

	}

})(jQuery);
